import React, { useEffect } from 'react';
import styles from '../../styles/SidePanel.module.css';

interface SidePanelProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  icon?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

const SidePanel: React.FC<SidePanelProps> = ({
  isOpen,
  onClose,
  title,
  icon,
  children,
  className = ''
}) => {
  // Handle escape key
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      // Prevent body scroll when panel is open
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };
  if (!isOpen) {
    return null;
  }

  return (
    <>
      {/* Overlay */}
      <div 
        className={`${styles.sidePanelOverlay} ${isOpen ? styles.active : ''}`}
        onClick={handleOverlayClick}
      />
      
      {/* Side Panel */}
      <div className={`${styles.sidePanel} ${isOpen ? styles.active : ''} ${className}`}>
        {/* Header */}
        <div className={styles.sidePanelHeader}>
          <div className={styles.sidePanelTitle}>
            {icon && (
              <span className={styles.titleIcon}>
                {icon}
              </span>
            )}
            {title}
          </div>
          <button 
            className={styles.closeBtn}
            onClick={onClose}
            type="button"
            aria-label="Close panel"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>
        
        {/* Content */}
        <div className={styles.sidePanelContent}>
          {children}
        </div>
      </div>
    </>
  );
};

export default SidePanel;
